import { api } from './api';

export interface OrganizationSettings {
  id: string;
  organizationId: string;
  timezone: string;
  locale: string;
  notificationPreferences: Record<string, any>;
  integrationSettings: Record<string, any>;
  featureFlags: Record<string, any>;
}

export const organizationSettingsService = {
  async getSettings(organizationId: string): Promise<OrganizationSettings> {
    const response = await api.get(`/organizations/${organizationId}/settings`);
    return response.data.data;
  },

  async updateSettings(
    organizationId: string, 
    settings: Partial<OrganizationSettings>
  ): Promise<OrganizationSettings> {
    const response = await api.put(`/organizations/${organizationId}/settings`, settings);
    return response.data.data;
  }
};
